import { HttpErrorResponse } from '@angular/common/http';
import { EventEmitter, Injectable, InjectionToken } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Subject, Subscription } from 'rxjs';
import { columnsDef } from '../interfaces/columnsDef';
import { ObjectUtil } from '../system-utils/utils/ObjectUtil';
import { DynamicFormsService } from './dynamic-forms.service';
import { HTTPService } from './http.service';



@Injectable()
export class SearchFieldService {
    
    loadRef( config:columnsDef, arrayColumnsDef:columnsDef[]):columnsDef{
      
        let configRef:columnsDef = null;

        if ( config.ISFK == 1 && config.REFERENCES!= null && config.DATATYPE!="SEARCHREFERENCE"){
            config.REFERENCES.forEach(ref=>{
              let arrayLen = arrayColumnsDef.filter(value=> value.COLUMNNAME.split("->")[0] == ref.CONSTRAINT_NAME && value.COLUMNNAME.indexOf("->") > -1
              && JSON.parse(value.VALIDATIONERROR)['ColumnName']== ref.CONSTRAINT_COLUMN );
              if ( arrayLen.length > 0 ){
                configRef = arrayLen[0];
                config.DATATYPE = "REFERENCE";
              }
            })
        }

        if ( config.ISFK == 1 && config.REFERENCES!= null && config.DATATYPE=="SEARCHREFERENCE"){
            configRef = arrayColumnsDef.filter(value=> value.COLUMNNAME.startsWith(config.COLUMNNAME) )[0]  
        }

        return configRef;
    }

    constructor(private httpService:HTTPService){}

    sub:Subscription;
    sub2:Subscription;

    ngOnDestroy(){
        if (this.sub!= null ) {this.sub.unsubscribe();}
        if (this.sub2!= null ) {this.sub2.unsubscribe();}
    }

    

    updateDesription(entityName:string,config:columnsDef,configRef:columnsDef,group:UntypedFormGroup, customCondition:string, dynamicServices:DynamicFormsService,editEvent:EventEmitter<boolean>){
        let ob:Object  = 
        {      
          entityName : entityName,
          showPresentation: true,
          showRelationship: false,
          rows: 1
        }; 
        
        if ( config.COLUMNNAME.indexOf("->")>-1){
          let col:string = config.COLUMNNAME.split("->")[0];
    
          if ( config.DATATYPE == "SEARCHREFERENCE"){
            col = config.refName != null ? config.refName.toString() : config.COLUMNNAME.split("->")[0];
          }

          let controlName = config.COLUMNNAME.split("->")[0];

          if ( config.headerName != null ){
              controlName = config.headerName;
          }
          
          if ( (group.value[controlName] != null && ObjectUtil.isNotEmpty(group.value[controlName])) || 
               (group.get(controlName) != null && ObjectUtil.isNotEmpty(group.get(controlName).value)) 
               ) {
            if ( ObjectUtil.isNotEmpty(group.get(controlName).value)) {
                ob['condition'] = col +"="+ group.get(controlName).value;
            }else{
                if ( ObjectUtil.isNotEmpty(group.value[controlName])) {
                    ob['condition'] = col +"="+ group.value[controlName];
                }
            }
            
          }else{
            if ( group.contains(col)){
              group.get(col).setValue(null);
            }
    
            if ( group.contains(config.COLUMNNAME)){
              group.get(config.COLUMNNAME).setValue(null);
            }
            
            try{
              group.get(configRef.COLUMNNAME).patchValue(null);
            }catch(Exception){
    
            }
            
            return;
          }
          
        }else{
          
          if ( (group.value[config.COLUMNNAME] != null && ObjectUtil.isNotEmpty(group.value[config.COLUMNNAME])) || 
               (group.get(config.COLUMNNAME) != null && ObjectUtil.isNotEmpty(group.get(config.COLUMNNAME).value)) 
               ) {
            let columnRef  = config.REFERENCES[0].CONSTRAINT_COLUMN_REF;
            //let columnRef  = this.config.CONSTRAINT_COLUMN_REF;
            //ob['condition'] = columnRef +"="+ group.value[config.COLUMNNAME];

            if ( ObjectUtil.isNotEmpty(group.get(config.COLUMNNAME).value)) {
              ob['condition'] = columnRef +"="+ group.get(config.COLUMNNAME).value;
            }else{
                if ( ObjectUtil.isNotEmpty(group.value[config.COLUMNNAME])) {
                    ob['condition'] = columnRef +"="+ group.value[config.COLUMNNAME];
                }
            }
            
          }else{
            
            if ( group.contains(config.COLUMNNAME)){
              group.get(config.COLUMNNAME).setValue(null);
            }
            try{
              group.get(configRef.COLUMNNAME).patchValue(null);
            }catch(Exception){
              
            }
            
            return;
          }
        }
        
        if ( customCondition ){
          ob['condition'] = ob['condition']+ " AND " + customCondition;
        }
        if (dynamicServices!= null){
            dynamicServices.loadingIndicator = true;
        }
        
        
        this.sub = this.httpService.post(ob,"JsonBrokerServices/find",false).subscribe(
          dataInfo=>{
              if ( dataInfo[entityName] != null && dataInfo[entityName].length > 0 ){
                if (dynamicServices!= null){
                    dynamicServices.editingEventHandle(null);
                }
                let ti:columnsDef[] =  dataInfo['table_information'] ;
                
                if ( config.DATATYPE !="SEARCHREFERENCE"){
                  let reverseCol = configRef.COLUMNNAME.split("->")[1];
                  group.get(configRef.COLUMNNAME).patchValue(dataInfo[entityName][0][reverseCol]);
                  
                }else{
                  group.get(configRef.COLUMNNAME).patchValue(dataInfo[entityName][0][configRef.COLUMNNAME.split("->")[1]]);
                }
                
                if (dynamicServices!= null){
                    dynamicServices.loadingIndicator = false;
                }
                if ( editEvent!= null){
                    editEvent.next(true);
                }
                
              }else{
                var ob:Object = new Object();
                ob[configRef.COLUMNNAME] = "";
                ob[config.COLUMNNAME] = "";
                group.patchValue(ob);
                if ( config.DATATYPE =="SEARCHREFERENCE"){
                  group.get(configRef.COLUMNNAME).patchValue(null);

                  if ( configRef.headerName != null ){
                    group.get(configRef.headerName).patchValue(null);
                  }else{
                    group.get(configRef.COLUMNNAME.split("->")[0]).patchValue(null);
                  }
                }
                if ( editEvent!= null){
                    editEvent.next(true);
                }
              }
              
        },
        (error)=>{
            if (dynamicServices!= null){
                dynamicServices.loadingIndicator = false;
            }
        },
        ()=>{
            if (dynamicServices!= null){
                dynamicServices.loadingIndicator = false;
            }
        });
       
      }
    
 

}